<template>
  <router-view />
</template>

<script>
export default {};
</script>

<style>
@font-face {
  font-family: "Nunito";
  src: local("Nunito"), url(./fonts/Nunito.ttf) format("truetype");
}
</style>
